import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
  selector: 'app-popover-standard-confirm',
  templateUrl: './popover-standard-confirm.component.html',
  styleUrls: ['./popover-standard-confirm.component.scss'],
})
export class PopoverStandardConfirmComponent implements OnInit {

  public data: any;

  constructor(
    private readonly navigator: Navigator,
    private popoverController: PopoverController
  ) {
  }

  ngOnInit(): void {
    this.data = this.navigator.activePopovers[this.navigator.activePopovers.length - 1].componentProps.data.message;
  }

  public onClose = () => {
    if (!!this.data.decline) this.data.decline();
    return this.popoverController.dismiss();
  }

  public onConfirm() {
    if (!!this.data.confirm) return this.data.confirm();
    return this.popoverController.dismiss();
  }


  public onConfirmLink() {
    if (!!this.data.confirmLink) this.data.confirmLink();
    return this.popoverController.dismiss();
  }


}
